<div class = "button-container">
  <app-button-shared buttonType="contact-us" variant="flat" color="primary"></app-button-shared> <!-- Forces flat -->
  <app-button-shared buttonType="enquire" variant="flat" color="primary"></app-button-shared> <!-- Forces flat -->
</div>
